import React from 'react';
import { Icon } from 'rmwc/Icon';


export const InfoGlyph = props => (
  <div style={{paddingLeft:"5px", paddingRight:"5px"}}>
    <a href={props.href}
      target={props.target?props.target:""}
      style={{textDecoration: "none"}}
    >
      <div style={{
        height:"100px",
        width:"100px",
        color:"white",
        background:"linear-gradient(to bottom right, #ef9b67 50%, #ec6f32 50%)",
        borderRadius: "100px",
        margin:"0 auto"
      }}>
        <Icon
          style={{
            fontSize:"65px",
            paddingTop:"18px",

          }}
          use={props.icon}
        >
        </Icon>
      </div>
      <div style={{paddingTop:"20px", fontSize:"18px", color:"black"}}>{props.title}</div>
      <div style={{paddingTop:"15px", fontSize:"16px", color:"var(--detailTextColorDark)"}}>{props.text}</div>
    </a>
  </div>
)

/*

<Icon
  style={{height:"90px", width:"90px", color:"white", background:"linear-gradient(to bottom right, #ef9b67 50%, #ec6f32 50%)"}}
  use="favorite_outline"
/>
*/



// WEBPACK FOOTER //
// ./src/components/InfoGlyph.js